import styled from '@emotion/styled';
import { useSelector } from 'react-redux';
import useWindowSize from '@hooks/useWindowSize';
import Paper from '@base/Paper/Paper';
import Button from '@base/Button/Button';
import H3 from '@base/H3/H3';
import H5 from '@base/H5/H5';
import { getImage } from '@utils/imageHelper';
import pushRoute from '@utils/pushRoute';
import { subscriptionTypes } from '@constants/index';
import { getPlusSubscriptionInfoLatest } from '@selectors/subscription';
import { Spacings, Fonts, mediaQuery } from '@styles/index';

const RenewWrapper = styled(Paper)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${mediaQuery.aboveMobile} {
    background-image: url('${getImage('renewBannerBg.svg')}');
    background-repeat: no-repeat;
    background-position: left bottom;
  }
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_2B};
    margin-bottom: ${Spacings.SPACING_4B};
  }
`;

const RenewHeading = styled.div`
  margin-left: 15%;
  ${mediaQuery.uptoMobile} {
    margin-left: ${Spacings.SPACING_0B};
  }
  h3 {
    margin-bottom: ${Spacings.SPACING_2B};
    ${mediaQuery.uptoMobile} {
      font-size: ${Spacings.SPACING_4B};
    }
  }
  h5 {
    font-weight: ${Fonts.REGULAR};
    ${mediaQuery.uptoMobile} {
      font-size: ${Spacings.SPACING_3B};
    }
  }
`;

const RenewBanner = ({ goalInfo }) => {
  const { goalSlug, uid } = goalInfo || {};
  const { isMobile } = useWindowSize();
  const latestSubscription = useSelector(getPlusSubscriptionInfoLatest(uid));
  const renewClickHandler = () => {
    pushRoute(
      '/goal/[goalSlug]/[goalUID]/subscribe',
      `/goal/${goalSlug}/${uid}/subscribe`
    );
  };

  return (
    <>
      {latestSubscription?.subscription.type === subscriptionTypes.LITE &&
      latestSubscription?.time_remaining === 0 ? (
        <RenewWrapper
          gridColumn="span 18"
          padding={`${Spacings.SPACING_10B} ${Spacings.SPACING_12B}`}
        >
          <RenewHeading>
            <H3>Your subscription has expired</H3>
            <H5>To continue learning please renew your subscription.</H5>
          </RenewHeading>

          <Button
            label="Renew"
            grid={isMobile ? 2 : 4}
            variant="filled"
            onClick={renewClickHandler}
          />
        </RenewWrapper>
      ) : null}
    </>
  );
};

export default RenewBanner;
